import React from "react";
import { useContext } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {
	Link,
	useLocation,
	useNavigate,
	useNavigation,
} from "react-router-dom";
import { FaArrowAltCircleRight, FaGoogle, FaGithub } from "react-icons/fa";
import { AuthContext } from "../UserContext/AuthProvider";
import { GithubAuthProvider, GoogleAuthProvider } from "firebase/auth";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
	const googleProvider = new GoogleAuthProvider();
	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/";
	const gitProvider = new GithubAuthProvider();
	const { handleSignIn, user, handleLoginEmailPass } = useContext(AuthContext);
	
	const handleGoogleLogin = () => {
		
		handleSignIn(googleProvider)
			.then(res => navigate(from, { replace: true }))
			
			.catch((err) => console.log(err.message))
	};
	const handleGitLogin = () => {
		handleSignIn(gitProvider)
			.then(res => navigate(from, { replace: true }))
			.catch((err) => console.log(err.message));
	};
	const handleLoginWithEmail = (e) => {
		e.preventDefault();
		handleLoginEmailPass(e.target.email.value, e.target.password.value)
		.then((res) => {
				if(res.user.uid){
					navigate(from, { replace: true });
				}
				toast.success("Login Success");
			},
		)
		.catch(err => {
			toast.error(err.message,{
				position: toast.POSITION.TOP_CENTER
			  });
		})
	};
	return (
		<div className="container py-5">
			<div className="row">
				<div className="col-md-4 py-4 border border-3 offset-md-4 rounded theme_color">
					<Form onSubmit={handleLoginWithEmail} className=" p-3">
						<h2 className="fw-bolder">Login Here</h2>
						<Form.Group className="mb-3" controlId="formBasicEmail2">
							<Form.Label>Email address</Form.Label>
							<Form.Control
								name="email"
								type="email"
								placeholder="Enter email"
							/>
						</Form.Group>

						<Form.Group className="mb-3" controlId="formBasicPassword">
							<Form.Label>Password</Form.Label>
							<Form.Control
								name="password"
								type="password"
								placeholder="Password"
							/>
						</Form.Group>
						<Button
							className="w-100 border-0 py-2 fw-bolder bg-black btn"
							type="submit"
						>
							Submit
						</Button>
					</Form>
					<div className="d-flex justify-content-between my-2">
						<Link
							to="/forget"
							className="text-decoration-none text-black fw-bolder"
						>
							Forget Password?
						</Link>
						<Link
							to="/register"
							className="text-decoration-none text-black fw-bolder"
						>
							Register Here <FaArrowAltCircleRight></FaArrowAltCircleRight>{" "}
						</Link>
					</div>
					<h3 className="d-flex justify-content-between fw-bolder">
						<hr style={{ width: "40%" }} className=" border-3 border-top" /> OR{" "}
						<hr
							style={{ width: "40%" }}
							className="border-3 border-top theme_color"
						/>
					</h3>
					<div className="d-flex justify-content-evenly mt-3">
						<div
							style={{ cursor: "pointer" }}
							onClick={handleGoogleLogin}
							className="border border-3 px-3 rounded theme_color py-2"
						>
							<FaGoogle></FaGoogle> Google
						</div>
						<div
							onClick={handleGitLogin}
							style={{ cursor: "pointer" }}
							className="border border-3 px-3 rounded theme_color py-2"
						>
							<FaGithub></FaGithub> GitHub
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Login;
